import { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useApp } from '../../hooks/useApp'

const ApprovePayment: FC = () => {
  const { search } = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { setLoading, setErrorMsg, setSuccessMsg } = useApp()
  const [paymentStatus, setPaymentStatus] = useState<string | null>(null)

  useEffect(() => {
    // Obtener la URL actual
    const url = new URL(window.location.href)

    // Obtener el valor del parámetro 'code'
    const codeParam = url.searchParams.get('code')
    setPaymentStatus(codeParam)

    // Si el pago fue exitoso, mostrar mensaje de éxito
    if (codeParam === '1') {
      setSuccessMsg && setSuccessMsg(t('paymentSuccessful'))
    } else {
      setErrorMsg && setErrorMsg(t('paymentFailed'))
    }
  }, [search, setSuccessMsg, setErrorMsg, t])

  const handleGoBack = () => {
    navigate('/')
  }

  const handleGoToConfirmation = () => {
    navigate('/bookings', { state: { goToConfirmation: true } })
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50 p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 text-center">
        {paymentStatus === '1' ? (
          <>
            <div className="flex justify-center mb-6">
              <svg
                className="w-20 h-20 text-green-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('paymentSuccessful')}</h2>
            <p className="text-gray-600 mb-8">{t('paymentSuccessfulMessage')}</p>
            <button
              onClick={handleGoToConfirmation}
              className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {t('goToConfirmation')}
            </button>
          </>
        ) : (
          <>
            <div className="flex justify-center mb-6">
              <svg
                className="w-20 h-20 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">{t('paymentFailed')}</h2>
            <p className="text-gray-600 mb-8">{t('paymentFailedMessage')}</p>
            <button
              onClick={handleGoBack}
              className="w-full py-3 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              {t('tryAgain')}
            </button>
          </>
        )}

        <div className="mt-8 pt-6 border-t border-gray-200">
          <div className="flex justify-center space-x-4">
            <img
              src="https://www.tilopay.com/images/LogoTilopay.svg"
              alt="Tilopay"
              className="h-8"
            />
          </div>
          <p className="text-xs text-gray-500 mt-4">{t('securePayment')}</p>
        </div>
      </div>
    </div>
  )
}

export default ApprovePayment
